import { useSelector } from 'react-redux';

import { features } from '../../dashboards/dashboardFramework/helpers/features';

export const useHasBuildingGroupFeature = (): boolean =>
  useSelector((state: any) =>
    Boolean(state?.user?.globalFeatures?.includes(features.BUILDING_GROUP)),
  );
